import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    connect() {
        const pageAccessedByReload = (
            (window.performance.navigation && window.performance.navigation.type === 1) ||
            window.performance
                .getEntriesByType('navigation')
                .map((nav) => nav.type)
                .includes('reload')
        );

        const heading = this.element.querySelector('#profileHeading');
        if (!pageAccessedByReload && heading) {
            heading.scrollIntoView({
                block: "start"
            });
        }
    }
}
